export const TEST_IDS = {
  consents: {
    form: "consents-form",
    container: "acceptance-checkboxes",
    checkbox: "consent-checkbox",
    item: (index: number) => `consent-item-${index}`,
    continueButton: "consents-continue-button",
  },
  basicData: {
    form: "basic-data-form",
    nameInput: "actor-name-input",
    firstSurnameInput: "actor-first-surname-input",
    secondSurnameInput: "actor-second-surname-input",
    idNumberInput: "actor-id-number-input",
    continueButton: "basic-data-continue-button",
  },
  representedEntityData: {
    companyNifInput: "company-nif-input",
    companyNameInput: "company-name-input",
    representativeIdNumberInput: "representative-id-number-input",
    representativeRelationTypeSelect: "representative-relation-type-select",
    continueButton: "represented-entity-data-continue-button",
  },
  orders: {
    box: (typeOrKey: string) => `order-box-${typeOrKey.toLowerCase()}`,
    header: (typeOrKey: string) => `order-header-${typeOrKey.toLowerCase()}`,
    fileInput: "order-file-input",
    uploadButton: "order-upload-button",
  },
  identityVerification: {
    manualUploadButton: "identity-verification-manual-upload-button",
    documentTypeSelect: "identity-verification-document-type-select",
    countrySelect: "identity-verification-country-select",
    fileInput: (side: string) => `identity-verification-${side}-file-input`,
  },
} as const;
